import React from "react";

export default function Phrase(props) {
  
  
  
    return (
    <div className="Phrase">
      <h5>
        <em>{props.description}</em>
      </h5>
    </div>
  );
}
